export default function AboutKuu() {
  return (
    <section id="about" className="py-24 bg-[#3a4a28] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/41dbf82c053e0603bc6de749c77ac223.jpg)",
        }}
      />
      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-white/40 text-xs tracking-[0.4em] mb-6">CONCEPT</p>
            <h2 className="font-serif text-3xl md:text-4xl text-white leading-tight mb-8">
              整えて終わりではなく、<br />動ける身体へ。
            </h2>
            <p className="text-white/75 text-sm leading-loose mb-6 tracking-wide">
              一時的なリラクゼーションではなく、身体の根本から状態を整え、疲れにくく、動きやすい身体へ。
            </p>
            <p className="text-white/75 text-sm leading-loose tracking-wide">
              整体とトレーニングを組み合わせることで、日常もパフォーマンスも変えていきます。KUUは、ただ癒すだけでなく「動ける状態をつくる」ための場所です。
            </p>
          </div>
          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/98c8f721efe8e85064ec351cb642a7fc/4c69660905cca2b80513d899da6a843f.jpeg"
                alt="KUU interior"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-[#2a3820] px-6 py-4 rounded-sm">
              <p className="text-white/60 text-xs tracking-widest">KAMAKURA</p>
              <p className="text-white text-sm font-serif mt-1">鎌倉・二階堂</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
